<!-- eslint-disable max-len -->
<template>
  <nav class="menu">
    <div class="acount">
      <router-link
        class="acount__link"
        :to="{ name: 'profile' }">
        <div class="acount__pic profile-heading__pic">
          <img
            v-if="avatarPath"
            :src="`/images/${avatarPath}`">
        </div>
        <div
          class="acount__name">
          {{ loginName }}
        </div>
      </router-link>
    </div>
    <ul class="menu-list">
      <li class="menu-list__node menu-list__home">
        <router-link
          :to="{ name: 'index' }"
          :class="{ 'menu-list-current': $store.state.sideMenuId === 'dashboard' }">
          <span class="menu-list__icon">
            <svg
              class="icon-home svg-icon"
              viewBox="0 0 21 20.15">
              <path
                class="color1"
                d="M3.4,20.15A1.432,1.432,0,0,1,2,18.82a1.769,1.769,0,0,1,
                0-.206V9.646H3v9c.016.339.226.517.464.5l4.036,0a.575.575,
                0,0,0,.5-.534V14.646a2.5,2.5,0,0,1,5,0V18.66a.517.517,0,0,0,.511.486H17.5a.538.538,
                0,0,0,.5-.519V9.646h1v9a1.55,1.55,0,0,1-1.482,1.5H13.5A1.524,1.524,0,0,
                1,12,18.677V14.646a1.5,1.5,0,0,0-3,0v4a1.593,1.593,0,0,1-1.465,1.5H3.5C3.467,
                20.149,3.434,20.15,3.4,20.15ZM20.887,9.163a.5.5,0,0,0-.07-.7L10.5,0,
                .182,8.459a.5.5,0,0,0,.635.774L10.5,1.293l9.682,7.94a.5.5,0,0,0,.705-.07Z" />
            </svg>
          </span>
          ダッシュボード
        </router-link>
        <ul class="menu-list-child">
          <li
            v-if="$store.state.auth.company.account_type === 0"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'release-single' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'release-single' }">
              シングル配信
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type === 0"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'release-album' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'release-album' }">
              アルバム配信（2曲以上）
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type === 0"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'release-index' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'my-release' }">
              マイリリース
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type === 0"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'artist-create' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'artist-create' }">
              アーティスト登録
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type === 0"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'artist-index' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'my-artist' }">
              マイアーティスト
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type === 0 && $store.state.auth.enable_link_map"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'link-index' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'link' }">
              LinkMAP
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.is_consumer === 1
              && $store.state.auth.company.account_type === 0"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'revenue-share' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'revenue-share' }">
              スプリット
            </router-link>
          </li>
          <li class="menu-list-child__node">
            <router-link
              :to="{ name: 'profile' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'profile' }">
              アカウント情報
            </router-link>
          </li>
          <li
            v-if="isBtoC"
            class="menu-list-child__node">
            <router-link
              :to="{ name: 'balance' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'payment' }">
              支払い申請
            </router-link>
          </li>
        </ul>
      </li>
      <li
        v-if="$store.state.auth.company.is_consumer === 1
          && $store.state.auth.company.account_type === 0"
        class="menu-list__node menu-list__copyright menu-list__accordion">
        <a href="javascript:void(0);">
          <span class="menu-list__icon">
            <span class="mdi mdi-copyright copyright-icon"></span>
          </span>
          著作権管理サービス
          <span class="menu-list__icon--accordion">
            <span></span>
          </span>
        </a>
        <ul class="menu-list-child">
          <li class="menu-list-child__node">
            <router-link
              :to="{ name: 'copyright-index' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'copyright-index' }">
              著作権管理
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.tier !== 'C'"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'copyright-splits'}"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'copyright-splits' }">
              著作権スプリット
            </router-link>
          </li>
          <li class="menu-list-child__node">
            <router-link
              :to="{ name: 'copyright-assignment-terms' }"
              :class="{ 'menu-list-current':
                $store.state.sideMenuId === 'copyright-assignment-terms' }">
              音楽著作権の期間及び限定譲渡に関する規約
            </router-link>
          </li>
        </ul>
      </li>
      <li
        v-if="$store.state.auth.company.enable_youtube_monetize_menu"
        class="menu-list__node menu-list__report menu-list__accordion">
        <a href="javascript:void(0);">
          <span class="menu-list__icon">
            <svg
              class="icon-report svg-icon"
              viewBox="0 0 512 512">
              <path
                class="color1"
                d="M474.322,123.216c-12.943-23.089-26.996-27.331-55.594-28.948
                  c-28.576-1.945-100.426-2.752-162.666-2.752c-62.367,0-134.247,
                  0.807-162.793,2.719c-28.538,1.65-42.619,5.864-55.678,28.981
                  c-13.336,23.06-20.194,62.776-20.194,132.696v0.241c0,69.615,
                  6.858,109.629,20.194,132.447
                  c13.059,23.091,27.107,27.277,55.654,29.218c28.57,1.678,100.45,
                  2.667,162.817,2.667c62.24,0,134.09-0.989,162.693-2.634
                  c28.604-1.94,42.646-6.133,55.594-29.218c13.449-22.82,
                  20.254-62.832,20.254-132.455v-0.239
                  C494.604,185.992,487.799,146.276,474.322,
                  123.216L474.322,123.216z M474.322,123.216" />
              <path
                d="M196.352,345.72V166.282L345.475,256L196.352,345.72z M196.352,345.72"
                style="fill:#FCFCFC;" />
            </svg>
          </span>
          YouTubeマネタイズ
          <span class="menu-list__icon--accordion">
            <span></span>
          </span>
        </a>
        <ul class="menu-list-child">
          <li class="menu-list-child__node">
            <router-link
              :to="{ name: 'youtube-claims-search-index' }"
              :class="{
                'menu-list-current': $store.state.sideMenuId === 'youtube-claims-search-index'
              }">
              申し立て動画検索
            </router-link>
          </li>
          <li class="menu-list-child__node">
            <router-link
              :to="{ name : 'youtube-claims-request-index'}"
              :class="{
                'menu-list-current': $store.state.sideMenuId === 'youtube-claims-request-index'
              }">
              手動申し立て
            </router-link>
          </li>
          <li class="menu-list-child__node">
            <router-link
              :to="{ name : 'youtube-claims-report-index'}"
              :class="{
                'menu-list-current': $store.state.sideMenuId === 'youtube-claims-report-index'
              }">
              申し立てレポート
            </router-link>
          </li>
        </ul>
      </li>
      <li
        class="menu-list__node menu-list__report menu-list__accordion">
        <a href="javascript:void(0);">
          <span class="menu-list__icon">
            <svg
              class="icon-report svg-icon"
              viewBox="0 0 19 24">
              <path
                class="color1"
                d="M0,23H18v1H0ZM0,12V22H3V12Zm2,9H1V13H2ZM7,8V21H6V8H7M8,7H5V22H8V7Zm4,
                6v8H11V13h1m1-1H10V22h3V12Zm4-4V21H16V8h1m1-1H15V22h3V7ZM17,2.5a.5.5,0,1,
                1-.5-.5A.5.5,0,0,1,17,2.5Zm2,0a2.491,2.491,0,0,1-3.821,2.115L12.492,
                7.382a1.5,1.5,0,1,1-2.26.324l-2.8-2.888a2.428,2.428,0,0,1-2.058-.1L2.636,
                7.531A1.484,1.484,0,0,1,3,8.5,1.5,1.5,0,1,1,1.5,7a1.42,1.42,0,0,1,
                .254.026L4.594,4.1a2.493,2.493,0,1,1,3.673.167l2.741,2.821A1.469,1.469,0,
                0,1,11.488,7L14.462,3.94A2.5,2.5,0,1,1,19,2.5ZM2,8.5a.5.5,0,1,0-.5.5A.5.5,
                0,0,0,2,8.5Zm6-6A1.5,1.5,0,1,0,6.5,4,1.5,1.5,0,0,0,8,2.5Zm4,6a.5.5,0,1,
                0-.5.5A.5.5,0,0,0,12,8.5Zm6-6A1.5,1.5,0,1,0,16.5,4,1.5,1.5,0,0,0,18,
                2.5ZM6.5,2a.5.5,0,1,0,.5.5A.5.5,0,0,0,6.5,2Z" />
            </svg>
          </span>
          レポート
          <span class="menu-list__icon--accordion">
            <span></span>
          </span>
        </a>
        <ul class="menu-list-child">
          <li class="menu-list-child__node">
            <router-link
              :to="{ name: 'report-realtime' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'report-realtime' }">
              速報レポート
            </router-link>
          </li>
          <li class="menu-list-child__node">
            <router-link
              :to="{ name : 'report-finalized'}"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'report-finalized' }">
              確定レポート
            </router-link>
          </li>
          <li
            v-if="isBtoB"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'report-finalized-list'}"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'report-finalized-list' }">
              報告書ダウンロード
            </router-link>
          </li>
        </ul>
      </li>
      <li class="menu-list__node menu-list__information">
        <router-link
          :to="{ name: 'information-index' }"
          class="menu-list__link"
          :class="{ 'menu-list-current': $store.state.sideMenuId === 'information' }">
          <span class="menu-list__icon">
            <svg
              class="icon-info svg-icon"
              viewBox="0 0 17.044 21.032">
              <path
                class="color1"
                d="M1.322,21.032a1.352,1.352,0,0,1-.328-.041,1.324,1.324,0,0,
                1-.968-1.54V1.507a1.065,1.065,0,0,1,0-.275A1.4,1.4,0,0,1,
                1.585.01l11.148,0,.146.146c4.047,4.04,4.047,4.04,4.091,
                4.124a.5.5,0,0,1-.815.564C16,4.679,13.84,2.525,12.319,
                1.007H1.526a.446.446,0,0,0-.354.079.4.4,0,0,0-.15.267l0,
                .154L1.01,19.631a.323.323,0,0,0,.232.391.31.31,0,0,0,
                .16,0l.124-.015,14.105.011a.337.337,0,0,0,.406-.261.354.354,0,0,0,
                0-.145l-.011-.1-.013-12.5H12.526a2.919,2.919,0,0,
                1-2.494-2.422l-.006-3.078a.5.5,0,1,1,1,0v3a1.9,1.9,0,0,0,1.579,1.506l4.406-.006.015,
                13.452a1.362,1.362,0,0,1-.012.509,1.343,1.343,0,0,1-1.535,1.039H1.581A1.337,
                1.337,0,0,1,1.322,21.032Zm5.2-16.526h-2v2h2v-2m1-1v4h-4v-4Zm-3,8h8v-1h-8Zm0,
                3h8v-1h-8Zm0,3h8v-1h-8Z" />
            </svg>
          </span>
          インフォメーション
        </router-link>
      </li>
      <li class="menu-list__node menu-list__help menu-list__accordion">
        <a
          href="javascript:void(0);"
          class="menu-list__help--link">
          <span class="menu-list__icon">
            <svg
              class="icon-help svg-icon"
              viewBox="0 0 21 21">
              <path
                class="color1"
                d="M10.5,21A10.5,10.5,0,1,1,21,10.5,10.512,10.512,0,0,1,10.5,21Zm0-20A9.5,9.5,0,1,0,
                20,10.5,9.511,9.511,0,0,0,10.5,1ZM9.923,12.7a3.962,3.962,0,0,1,.171-1.374,3.446,
                3.446,0,0,1,.861-1.011,15.107,15.107,0,0,0,.964-1.231,1.834,1.834,0,0,0,.287-1.039,
                1.514,1.514,0,0,0-.387-1.114,1.483,1.483,0,0,0-1.1-.39,1.671,1.671,0,0,0-1.06.339,
                1.178,1.178,0,0,0-.437.994H7.934L7.913,7.83a2.128,2.128,0,0,1,.775-1.764A3.067,
                3.067,0,0,1,10.716,5.4a2.978,2.978,0,0,1,2.092.687,2.484,2.484,0,0,1,.745,1.918,
                2.864,2.864,0,0,1-.483,1.613,9.061,9.061,0,0,1-1.274,1.5,1.6,1.6,0,0,0-.448.663,
                3.9,3.9,0,0,0-.078.916Zm1.394,2.8H9.909V14.078h1.408Z" />
            </svg>
          </span>
          ヘルプ
          <span class="menu-list__icon--accordion">
            <span></span>
          </span>
        </a>
        <ul class="menu-list-child">
          <li
            v-if="$store.state.auth.company.account_type < 2 && appName !== 'PNDR'"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'faq' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'faq' }">
              よくある質問
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type < 2"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'store-detail' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'store' }">
              ストア詳細
            </router-link>
          </li>
          <li
            v-if="isBtoC && $store.state.auth.company.account_type < 2"
            class="menu-list-child__node">
            <a
              href="/lp/vocalo/"
              target="_blank">
              ボーカロイドの利用について
            </a>
          </li>
          <li
            v-if="$store.state.auth.company.account_type < 2"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'terms' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'terms' }">
              {{ isBtoC?'[narasu]':'' }}利用規約
            </router-link>
          </li>
          <li
            v-if="isBtoC && $store.state.auth.company.account_type < 2"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'copyright-terms' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'copyright-terms' }">
              著作権管理サービス利用規約
            </router-link>
          </li>
          <li
            v-if="appName === 'Zu-MAP'"
            class="menu-list-child__node">
            <router-link
              v-if="appName === 'Zu-MAP'"
              :to="{ name: 'zu-map_secondary-usage-fee-for-broadcasts-terms' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'zu-map_secondary-usage-fee-for-broadcasts-terms' }">
              放送二次使用料分配サービス(レコード製作者)利用規約
            </router-link>
          </li>
          <li
            v-if="isBtoC && $store.state.auth.company.account_type < 2"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'rules' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'rules' }">
              配信規定
            </router-link>
          </li>
          <li
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'environment' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'environment' }">
              推奨環境
            </router-link>
          </li>
          <li
            v-if="$store.state.auth.company.account_type < 2"
            class="menu-list-child__node">
            <router-link
              :to="{ name : 'contact' }"
              :class="{ 'menu-list-current': $store.state.sideMenuId === 'contact' }">
              お問い合わせ
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  computed: {
    loginName() {
      if (this.isBtoC) {
        return this.$store.state.auth.name
      }
      return this.$store.state.auth.company
        ? this.$store.state.auth.company.name
        : ''
    },
    avatarPath() {
      return this.$store.state.auth.avatarPath || ''
    },
  },
}
</script>
<style scoped>
.profile-heading__pic {
  background-image: url(../../../../public/img/common/account_pic.png);
  background-size: contain;
  height: 10vw;
  width: 10vw;
  max-width: 50px;
  max-height: 50px;
}
.acount__pic img {
  height: 100%;
}
</style>
